import { render, staticRenderFns } from "./TokenVariable.vue?vue&type=template&id=6f8e6a2d"
import script from "./TokenVariable.vue?vue&type=script&lang=js"
export * from "./TokenVariable.vue?vue&type=script&lang=js"
import style0 from "./TokenVariable.vue?vue&type=style&index=0&id=6f8e6a2d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports